export const paths = {
  navigation: {
    addContractFromBid: (bidId: number | string) => `/buyers/contract/import/bid/${bidId}`,
    addContractInterstitial: (award: boolean) =>
      `/buyers/contract/add${award ? '?award=true' : ''}`,
    awardedBids: '/buyers/bids?bidStatus=AW&myBids=true',
    contractDetails: (contractId?: string) => `/buyers/contract/${contractId}`,
    createContract: '/buyers/contract/create',
    dashboard: '/buyers/contract',
    documents: (contractId?: string, tab?: string) => {
      return contractId
        ? `/buyers/contract/${contractId}/documents/${tab || ''}`
        : '/buyers/contract/documents/';
    },
    reminders: (
      contractId?: string,
      options?: {
        addReminder?: boolean;
        reminderId?: string;
      },
    ) => {
      const searchParams = new URLSearchParams();
      if (options?.addReminder) {
        searchParams.append('add', 'true');
      }

      if (options?.reminderId) {
        searchParams.append('reminder', options.reminderId);
      }

      const queryString = searchParams.toString();

      return (
        (contractId ? `/buyers/contract/${contractId}/reminders/` : '/buyers/contract/reminders/') +
        (queryString ? `?${queryString}` : '')
      );
    },
    editDraft: (contractId?: string) => `/buyers/contract/edit/${contractId}`,
    searchContracts: '/buyers/contract/search',
  },
  api: {
    awardees: {
      add: (contractId: string) => `/contracts/${contractId}/awardees/contacts`,
      delete: (contractId: string, awardeeContactId: string) =>
        `/contracts/${contractId}/awardees/contacts/${awardeeContactId}`,
      update: (contractId: string, awardeeContactId: string) =>
        `/contracts/${contractId}/awardees/contacts/${awardeeContactId}`,
    },
    contracts: {
      create: '/contracts',
      get: (contractId: string) => `/contracts/${contractId}`,
      search: '/contracts/search',
      update: (contractId: string) => `/contracts/${contractId}`,
      publish: (contractId: string) => `/contracts/${contractId}/activate`,
    },
    documents: {
      update: (contractId: string) => `/contracts/${contractId}/documents`,
      delete: (contractId: string, documentId: string) =>
        `/contracts/${contractId}/documents/${documentId}`,
      types: {
        create: '/document-type-types',
        get: (documentTypeId: string) => `/document-type-types/${documentTypeId}`,
        list: '/document-type-types',
        update: (documentTypeId: string) => `/document-type-types/${documentTypeId}`,
      },
    },
  },
} as const;
